import { Env } from '../global/interfaces/application-configuration';

class EnvironmentController {
  constructor() {
    for (let [key, value] of Object.entries(window.__env__)) {
      this[key] = value;
    }
  }
}

export const Environment = new EnvironmentController() as Env;
